import { useTranslation } from 'react-i18next';
import { RenderDataWithFallback, ListEmpty } from '@anytag/shared-atoms';
import { useInfluencerAddRoute } from '@anytag/shared-hooks';
import { useFacebookPageInfluencersContext } from '../FacebookPageInfluencersContext';
import { ProfileWidget } from './ProfileWidget';

export const FacebookPageInfluencersList = () => {
  const { t } = useTranslation();
  const { allowAddInfluencer, addInfluencerRoute } = useInfluencerAddRoute();
  const { loading, listRecords, getListSelectButtonProps } = useFacebookPageInfluencersContext();

  return (
    <RenderDataWithFallback
      loading={loading}
      hasNoData={listRecords.length === 0}
      noDataNode={
        <ListEmpty
          linkProps={allowAddInfluencer ? { label: t('add an influencer'), href: addInfluencerRoute } : undefined}
        />
      }
    >
      {listRecords.map((profile, index) => (
        <ProfileWidget
          key={`influencer-${profile.id}-${index}`}
          profile={profile}
          selectButtonProps={getListSelectButtonProps?.(profile)}
        />
      ))}
    </RenderDataWithFallback>
  );
};
